import { render, staticRenderFns } from "./DashBoardSideBar.vue?vue&type=template&id=34b2c578&scoped=true&"
import script from "./DashBoardSideBar.vue?vue&type=script&lang=js&"
export * from "./DashBoardSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b2c578",
  null
  
)

export default component.exports